// @flow

import { type UserInputValidationError, type UserInputValidatorArgs, onlyWhenSupport, VALID } from '@tectonics/prs/validation';

import { validateBrazilianDocument } from './brazilian-document';
import { validateBrazilianPhoneNumber } from './brazilian-phone-number';
import { validateBrazilianZipcode } from './brazilian-zipcode';
import { validateBrazilianState } from './brazilian-state';
import { validateBrazilianCity } from './brazilian-city';
import { validateBrazilianAddress } from './brazilian-address';
import { validateBrazilianStreetNumber } from './brazilian-street-number';
import { getCurrentFeatures } from '@tectonics/prs/payment-spec';

export function validator({
  spec,
  prsSupport,
  userInputName,
  userInputValue,
  userInputValues,
}: UserInputValidatorArgs): ?UserInputValidationError {
  const currentFeatures = getCurrentFeatures(spec, userInputValues['selectedPaymentMethod']);
  const onlyWhen = onlyWhenSupport(currentFeatures, prsSupport);

  switch (userInputName) {
    case 'brazilianDocument':
      return onlyWhen('field_brazilian_document') && validateBrazilianDocument(userInputValue, userInputValues['brazilianDocumentType']);

    case 'brazilianPhoneNumber':
      return onlyWhen('field_brazilian_phone_number') && validateBrazilianPhoneNumber(userInputValue);

    case 'brazilianZipcode':
      return onlyWhen('field_brazilian_zipcode') && validateBrazilianZipcode(userInputValue);

    case 'brazilianState':
      return onlyWhen('field_brazilian_state') && validateBrazilianState(userInputValue);

    case 'brazilianCity':
      return onlyWhen('field_brazilian_city') && validateBrazilianCity(userInputValue);

    case 'brazilianAddress':
      return onlyWhen('field_brazilian_address') && validateBrazilianAddress(userInputValue);

    case 'brazilianStreetNumber':
      return onlyWhen('field_brazilian_street_number') && validateBrazilianStreetNumber(userInputValue);

    default:
      return VALID;
  }
}
